export default "__VITE_ASSET__YNvdCnXL__"